:host {
  display: block;
  max-width: 100%;
  height: 100%;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}

.company-selector-action {
  display: flex;
  justify-content: end;
  padding: 4px calc(2 * var(--spacer));
  background: var(--white-layout-301-level-0-elevation);
}

#company-selector {
  width: auto;
}

.wrapper {
  flex-direction: column;
  background: var(--white-layout-301-level-0-elevation);

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .loading-container {
      display: flex;
    }
  }

  &.is-error {
    .loading-error {
      display: block;
    }
  }
}

.integrity-monitor-push-body {
  height: 100%;
  width: 100%;
}

[slot='push-body-content'] {
  height: 100%;
  width: 100%;
}

.integrity-monitor-form {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
}
